<template>
  <div class="play-container">
    <top-bar :user="user" />
    <Menu :user="this.user" :menuSelected="{ profile: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/cms-mkt/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/cms-mkt/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/cms-mkt/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/cms-mkt/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/cms-mkt/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <Menu :user="this.user" :menuSelected="{ profile: true }" />
    </div>
    <div class="container-right">
      <div :class="{
        content: true,
        'profile': true,
      }">
        <div>
          <div class="left">
            <h1>{{ $t("cmsLang.profileName") }}</h1>
          </div>
        </div>
        <br clear="all" />

        <div class="addRewardLayout border-box flex-wrap flex-xl-nowrap justify-content-center">
          <!-- <div class="container-alb"> -->
          <div class="contact-details-wrapper">
            <div class="text">
              <img class="square-75 border-round" :src="this.getImagePath() +
                'users/user_' +
                this.user.id +
                '.png'
                " @error="($event.target.src = require('@/assets/images/cms-mkt/offer_0.svg'))" w />
              <p class="font-18">
                {{
                  this.user.first_name +
                  " " +
                  this.user.last_name
                }}
              </p>
              <br clear="all" />
              <p class="opacity50 description">
                {{
                  this.user.email
                }}
              </p>
              <br clear="all" />
              <p>
                {{ $t('cmsLang.userRole_' + this.user.config.roles[0]) }}
              </p>
            </div>
            <br />
            <div>
              <div>
                <small>{{ $t("cmsLang.lastNameLabel") }}</small>
                <br />
                <input disabled type="text" required v-model="lastName" class="formedituser" />
                <small>{{ $t("cmsLang.firstNameLabel") }}</small>
                <br />
                <input disabled type="text" required v-model="firstName" class="formedituser" />
              </div>
              <!-- password  -->
              <div class="text-left">
                <small>{{ $t("cmsLang.passwordField") }}</small>
                <br />
                <input v-model="newPassword" @input="validatePassword" required class="formedituser" :type="'password'" />
                <small>{{ $t("cmsLang.confirmPasswordField") }}</small>
                <br />
                <input required :style="confirmPasswordStyle" @input="validatePassword" v-model="confirmPassword"
                  class="formedituser" :type="'password'" />

                <small style="margin-bottom: 10px;">
                  <img v-if="!isIE" :src="this.validPassword.passwordLengthValid
                    ? require('@/assets/images/yes.png')
                    : require('@/assets/images/no.png')
                    " />
                  &nbsp; {{ $t("cmsLang.passwordCriteria1Text") }}
                </small>
                <br />
                <small style="margin-bottom: 10px;">
                  <img v-if="!isIE" :src="this.validPassword.containsLetter
                    ? require('@/assets/images/yes.png')
                    : require('@/assets/images/no.png')
                    " />
                  &nbsp; {{ $t("cmsLang.passwordCriteria2Text") }}
                </small>
                <br />
                <small style="margin-bottom: 10px;">
                  <img v-if="!isIE" :src="this.validPassword.containsNumber
                    ? require('@/assets/images/yes.png')
                    : require('@/assets/images/no.png')
                    " />
                  &nbsp; {{ $t("cmsLang.passwordCriteria3Text") }}
                </small>
              </div>
              <br />
              <a @click="submitDetails()" class="button-all ">
                {{ $t("cmsLang.changePasswordLabel") }}
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>
    <modal-loading />
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.error">
          <p v-html="$t('cmsLang.error_' + this.error.code)"></p>
        </div>
        <div v-else>
          <p>{{ $t("cmsLang.personModifySuccess") }}</p>
        </div>
      </div>
    </div>

    <ResetPassword v-if="this.isUserNew(this.user)" :user="this.user" />

  </div>
</template>

<script>
import Cookies from "js-cookie";
import TopBar from "@/components/cms-mkt/TopBar.vue";
import Menu from "@/components/cms-mkt/Menu.vue";
import validator from "@/plugins/fieldValidation";
import ModalLoading from "@/components/fragments/cms-mkt/ModalLoading.vue";
import httpServiceUser from "@/http/http-user-mkt.js";
import ResetPassword from "@/components/fragments/cms-mkt/ResetPasswordPopup.vue";


export default {
  name: "Profile",
  components: {
    TopBar, Menu,
    ModalLoading,
    ResetPassword
  },
  data() {
    return {
      user: null,
      error: null,
      previewImage: null,
      message: "",
      functions: [{
        code: 4,
        name: "Sales manager"
      }],
      firstName: "",
      lastName: "",
      newPassword: null,
      confirmPassword: "",
      validPassword: {
        passwordValid: false,
        passwordLengthValid: false,
        containsLetter: false,
        containsNumber: false,
        confirmPasswordValid: false
      },
      isIE: false,

    };
  },
  methods: {
    validatePassword() {
      this.validPassword = validator.validatePassword(
        this.newPassword,
        this.confirmPassword
      );
    },
    submitDetails() {
      this.showModalPopup("modal_popup_loading_cms", true);
      this.error = null;
      let submitUser = {
        id: this.user.id,
      }
      let toUpdate = false;
      if (this.newPassword && this.newPassword != "") {
        if (!this.validPassword.passwordValid) {
          this.error = {
            code: "BPIP"
          };
          this.showModalPopup("modal_popup_loading_cms", false);
          // this.showModalPopup("modal_popup_resetPassword", true);
          this.showModalPopup("modal_popup_info", true);
          return;
        } else {
          submitUser.current_password = this.newPassword;
          submitUser.new_password = this.newPassword;
          toUpdate = true;
        }
      }
      if (this.firstName !== this.user.first_name || this.lasttName !== this.user.last_name) {
        submitUser.first_name = this.firstName;
        submitUser.last_name = this.lastName;
        toUpdate = true;
      }
      if (!toUpdate) {
        return;
      }
      httpServiceUser.userService
        .modifyUser(
          this.user.id,
          submitUser,
          Cookies.get("token")
        )
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          this.error = error.response.data;
          this.showModalPopup("modal_popup_loading_cms", false);
          this.showModalPopup("modal_popup_info", true);
          // this.showModalPopup("modal_popup_resetPassword", true);
        })
        .then((response) => {
          if (response.status == 200) {
            this.error = null;
            this.newPassword = null;
            this.confirmPassword = null;
            // this.user = this.getUser(true);
            this.showModalPopup("modal_popup_info", true);
          } else if (response.status == 400) {
            this.error = response.data;
            this.showModalPopup("modal_popup_info", true);
          } else {
            this.error = { description: response.code };
            this.showModalPopup("modal_popup_info", true);
          }
          this.showModalPopup("modal_popup_loading_cms", false);
        });

    },
    logout() {
      Cookies.remove("user_data");
      Cookies.remove("token");
      this.$router.push({
        name: "login",
      });
    },
    uploadFile() {
      let input = this.$refs.fileInput1;
      let file = input.files;
      if (file && file[0]) {
        let readerReward = new FileReader();
        readerReward.onload = (e) => {
          if (!e) {
            this.user.image = btoa(readerReward.content);
          } else {
            this.user.image = btoa(e.target.result);
          }
        };
        // reader.readAsDataURL(file[0]);
        if (readerReward.readAsBinaryString) {
          readerReward.readAsBinaryString(file[0]);
        } else {
          alert("This browser does not support HTML5.");
        }

        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        if (reader.readAsBinaryString) {
        } else {
          alert("This browser does not support HTML5.");
        }
        // this.$emit("input", file[0]);
      }
    },
  },
  // watch: {
  //   user: function () {
  //     console.log(this.user);
  //     if (this.user) {
  //       this.firstName = this.user.first_name;
  //       this.lastName = this.user.last_name;
  //       this.newPassword = null;
  //       this.confirmPassword = null;
  //     }
  //   }
  // },
  created() {
    this.user = this.getUser();
    this.newPassword = null;
            this.confirmPassword = null;
    this.firstName = this.user.first_name;
    this.lastName = this.user.last_name;
  },
  computed: {
    confirmPasswordStyle() {
      return this.confirmPassword === ""
        ? ""
        : this.newPassword === this.confirmPassword
          ? ""
          : "outline-color: #ff0000a6;";
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css" />

<style scoped src="@/assets/styles/mkt-cms.css"></style>
<style scoped>
.contact-details-wrapper {
  flex-direction: column;
  align-items: flex-start;
}

.font-18 {
  font-size: 18px;
}

.button-padding {
  padding-left: 30px;
  padding-right: 30px;
}

.padding-50 {
  padding: 50px;

}

.modal-popup-content p {
  border: none;

}

.button-all {
  border: 2px solid #fff !important;
}

.description {
  color: #00000066;
}
</style>
